import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu } from "@mui/material";
import { MenuItemProps } from "@mui/material";
import React, { ReactElement } from "react";
import { styled } from "@mui/system";

const StyledMenu = styled(Menu)({
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: 4,
  },
  "& .MuiMenuItem-root": {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
});

type DealDocumentRowItemActionsMenuProps = {
  dataTestId: string;
  children: ReactElement<MenuItemProps> | Array<ReactElement<MenuItemProps>>;
};
export const DealDocumentRowItemActionsMenu = (
  props: DealDocumentRowItemActionsMenuProps
) => {
  const children = Array.isArray(props.children)
    ? props.children
    : [props.children];
  const { dataTestId } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const overflowOpen = Boolean(anchorEl);

  const handleOverflowClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleOverflowClose = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <div className="overflow-container">
      <div
        style={{
          height: "48px",
          width: "48px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={handleOverflowClick}
      >
        <MoreVertIcon data-testid={dataTestId} className="overflow-icon" />
      </div>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={overflowOpen}
        onClose={handleOverflowClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {children.map((child, index) => {
          return (
            <div key={`${dataTestId}-${index}`} onClick={handleOverflowClose}>
              {child}
            </div>
          );
        })}
      </StyledMenu>
    </div>
  );
};
